import React, { MouseEvent, forwardRef, InputHTMLAttributes, useEffect, useState } from 'react';
import './InputSocialSecurity.css';
import InputBase from '../InputBase';
import { IInputProps } from '../InputBase/InputBase';
import { createLastCharacterVisibleMask } from '../../utils/utils';
interface IInputSocialSecurityProps extends IInputProps {
	className?: string;
	value: string;
	setValue: (ssn: string) => void;
	lastFour?: boolean;
	advancedMasking?: boolean;
}

const InputSocialSecurity = forwardRef(
	(
		{
			className = '',
			value = '',
			setValue,
			lastFour = false,
			onFocus,
			onBlur,
			advancedMasking = false,
			type = 'tel',
			...rest
		}: IInputSocialSecurityProps & InputHTMLAttributes<any>,
		ref: any,
	) => {
		const getRawVal = (val: string) => val?.replace(/[^0-9]/g, '');
		const isSsnValid = (val: string) => getRawVal(val)?.length === (lastFour ? 4 : 9);
		const isCurrentlyMasked = (fieldValue: string, fieldFocus: boolean, fieldVisible: boolean): boolean => !fieldFocus && !fieldVisible && isSsnValid(fieldValue)

		const [isVisible, setIsVisible] = useState(false);
		const [isFocused, setIsFocused] = useState(false);

		const mask = lastFour ? 'XXX0' : 'XXX-XX-0000';
		const unMask = lastFour ? '0000' : '000-00-0000';

		const [maskObjects, setMaskObjects] = useState(
			advancedMasking 
				? createLastCharacterVisibleMask(value) 
				: mask
		)


		useEffect(()=>{
			if (!advancedMasking) {
				if (isCurrentlyMasked(value, isFocused, isVisible)) {
					setMaskObjects(mask);
				} else {
					setMaskObjects(unMask)
				}
			} else {
				setMaskObjects(createLastCharacterVisibleMask(value, isVisible));
			}
        }, [isVisible, isFocused, value])

		return (
			<InputBase
				{...rest}
				autoComplete='off'
				type='tel'
				mask={maskObjects}
				eager={true}
				lazy={true}
				isVisible={isVisible}
				setIsVisible={setIsVisible}
				className={`InputSocialSecurity ${className}`}
				value={value}
				ref={ref}
				minLength={0}
				maxLength={lastFour ? 4 : 11}
				isValid={isSsnValid}
				onBlur={(e: React.FocusEvent<HTMLInputElement>)=>{
                    onBlur && onBlur(e);
					setIsFocused(false);
                }}
				onFocus={(e: React.FocusEvent<HTMLInputElement>)=> {
                    onFocus && onFocus(e);
					setIsFocused(true);
                }}
				advancedMasking={true}
				setValue={setValue}
				definitions={
				{
					X: {
						mask: '0',
						displayChar: '*',
						placeholderChar: ' '
					}
				}}
				{...(advancedMasking && {
					blurPlaceholderChar: '_',
					definitions: {
						X: {
							mask: '0',
							displayChar: '*',
							placeholderChar: '*'
						},
					},
					onMouseDown: (e: MouseEvent<HTMLInputElement> ) => {
						e.preventDefault();
						e.currentTarget.focus()
					}
				})}
			/>
		)
	},
);

InputSocialSecurity.displayName = 'InputSocialSecurity';

export default InputSocialSecurity;
